<div class="dialog-wrapper payment-plan-modal" rtl>
    <div mat-dialog-title>
        <h1 class="title">
            {{ 'CHOOSE_PAYMENT_METHOD' | translate }}
            <i class="icon close-icon" [inlineSVG]="'#close'" (click)="closeDialog()"></i>
        </h1>
    </div>

    <div mat-dialog-content>
        <div class="plan" *ngIf="!isShowStripe">
            <div class="best" *ngIf="data.clubPromotion">
                {{'BEST_OFFER' | translate}}
            </div>
            <div class="plan-title">
                <div class="name">{{data.name}}</div>
                <div class="price">${{data.amount}} p/{{data.paymentCycle === 'YEAR' ? 'y' : 'm'}}</div>
            </div>
            <div class="info">
                <p>{{data.comments}}</p>
                <!-- <p>Join the ultimate membership (24-month commitment required) and enjoy:</p>
                <ul>
                    <li>Unlimited Live Tracking</li>
                    <li>First week of service FREE!</li>
                    <li>Huge discounts % Off Any Petloc8 Device</li>
                </ul> -->
            </div>
        </div>

        <div class="stripe" [hidden]="!isShowStripe">
            <div id="card-info" #cardInfo></div>
        </div>

    </div>

    <div class="dialog-actions" mat-dialog-actions>
        <button class="btn primary credit-card" (click)="creditCard()" mat-flat-button>
            <i class="icon" *ngIf="!isShowStripe" [inlineSVG]="'#credit-card'"></i>
            {{ (isShowStripe ? 'PAY' : 'CREDIT_CARD') | translate }}
        </button>
        <button class="btn basic pay-pal" (click)="paypal()" *ngIf="!isShowStripe" mat-flat-button>
            <i class="icon" [inlineSVG]="'#paypal'"></i>
            {{ 'Pay Pal' | translate }}
        </button>

        <button class="btn basic" (click)="onCancel()" *ngIf="isShowStripe" mat-flat-button>
            {{ 'CANCEL' | translate }}
        </button>

    </div>
</div>